'use strict';

module.exports = require('array-includes');



//////////////////
// WEBPACK FOOTER
// ./node_modules/es7-shim/Array.prototype.includes.js
// module id = 780
// module chunks = 0